import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import ReactDOM from 'react-dom';

const modalRoot = document.createElement('div');
modalRoot.style.zIndex = '1000';
modalRoot.style.position = 'absolute';
modalRoot.id = 'modal-root';
document.body.insertBefore(modalRoot, document.body.firstChild);

function RsModal({ showModal = true, showBackdrop, children, className }) {
  return ReactDOM.createPortal(
    <RsModalComponent showModal={showModal} showBackdrop={showBackdrop} className={className}>
      {children}
    </RsModalComponent>,
    modalRoot
  );
}

const STATE_INIT = 0;
const STATE_DISPLAYING = 1;
const STATE_DISPLAY = 2;
const STATE_CLOSING = 3;
const STATE_HIDDEN = 4;

const isVisibleState = (modalState) => modalState === STATE_DISPLAYING || modalState === STATE_DISPLAY;

function RsModalComponent({ showModal, showBackdrop, children, className }) {
  const [modalState, setModalState] = useState(STATE_INIT);
  const timerRef = useRef(null);

  useEffect(() => {
    const cleanTimeout = () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };

    const delayedStateChange = (newState) => {
      cleanTimeout();
      timerRef.current = setTimeout(() => {
        setModalState(newState);
      }, 250);
    };

    const isVisible = isVisibleState(modalState);
    if (showModal && !isVisible) {
      setModalState(STATE_DISPLAYING);
      delayedStateChange(STATE_DISPLAY);
    } else if (!showModal && isVisibleState(modalState)) {
      setModalState(STATE_CLOSING);
      delayedStateChange(STATE_HIDDEN);
    }
    return () => cleanTimeout();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showModal]);

  return showModal || modalState === STATE_DISPLAY || modalState === STATE_CLOSING ? (
    <div
      className={cn(
        'react-dialogs-root',
        { 'react-dialogs-with-backdrop': !!showBackdrop },
        { 'react-dialogs--state-closing': modalState === STATE_CLOSING },
        { 'react-dialogs--state-opening': modalState === STATE_DISPLAYING },
        { 'react-dialogs--state-hidden': modalState === STATE_HIDDEN },
        className
      )}>
      {children}
    </div>
  ) : null;
}

RsModal.propTypes = {
  showBackdrop: PropTypes.bool,
  showModal: PropTypes.bool,
};

export default RsModal;
